module.exports = __webpack_public_path__ + "img/frown.e045dd04.svg";